import React from 'react';
import {TextContainer} from '@shopify/polaris';
import {Service} from 'sections/types';
import {ServiceCardContainer} from '..';
import {Routes, fetchTaxonomy} from '../../utilities';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {LinkLikeText} from 'sections/services-marketplace/components';
import i18nArgs from './locales';

interface OwnProps {
  service: Service;
  imageSrc?: string;
  imageSrcSet?: string;
}

type CombinedProps = OwnProps & WithI18nProps;

function ServiceCard({service, imageSrc, imageSrcSet, i18n}: CombinedProps) {
  const taxonomy = fetchTaxonomy();
  const link = Routes.servicePath(taxonomy, service.handle);

  return (
    <ServiceCardContainer
      serviceHandle={service.handle}
      label={service.shortLabel}
      imageSrc={imageSrc}
      imageSrcSet={imageSrcSet}
      link={link}
    >
      <TextContainer spacing="tight">
        <p>{service.description}</p>
        <p>
          <LinkLikeText>{i18n.translate('ServiceCard.linkText')}</LinkLikeText>
        </p>
      </TextContainer>
    </ServiceCardContainer>
  );
}

export default withI18n(i18nArgs)(ServiceCard);
